import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Articoli } from 'src/app/models/articoli';
import { GridScadenzeArticoliComponent } from 'src/app/shared/components/grid/grid-scadenze-articoli/grid-scadenze-articoli.component';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';

@Component({
  selector: 'app-articoli-details',
  templateUrl: './articoli-details.component.html',
  styleUrls: ['./articoli-details.component.scss'],
  imports: [GridScadenzeArticoliComponent],
  standalone: true,
})
export class ArticoliDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private nS = inject(NavigatorService);
  private articoliS = inject(ArticoliService);
  private alertS = inject(AlertService);

  idArticolo: number;

  articolo: Articoli;

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      if (+params.get('idArticolo') == 0) {
        this.nS.goToHome();
      } else {
        this.idArticolo = +params.get('idArticolo');
        console.log('idArticolo:' + this.idArticolo);
      }

      //Dettaglio pratica
      this.getArticolo(this.idArticolo);
    });
  }

  /**
   * Dettaglio del dipendente
   * @param idDipendente
   */
  getArticolo(idArticolo) {
    this.articoliS.get(idArticolo).subscribe((dati) => {
      this.articolo = dati;
    });
  }

  goToDipendenti() {
    this.nS.goToDipendenti();
  }
  goToArticolo() {
    this.nS.goToArticoli();
  }
}

